const homeScrollbutton = document.querySelector('.js-scroll-arrow');

if (typeof homeScrollbutton != "undefined" && homeScrollbutton != null) {

    homeScrollbutton.addEventListener('click', () => {
        gsap.to(window, {duration: 0.6, ease: "power4.easeInOut", scrollTo:"#js-scroll-destination"});
    });
}

const aboutScrollbutton = document.querySelector('.js-about-scroll');

if (typeof aboutScrollbutton != "undefined" && aboutScrollbutton != null) {

    aboutScrollbutton.addEventListener('click', () => {
        gsap.to(window, {duration: 0.6, ease: "power4.easeInOut", scrollTo:"#js-scroll-destination"});
    });
}

const communityScrollbutton = document.querySelector('.js-community-scroll');

if (typeof communityScrollbutton != "undefined" && communityScrollbutton != null) {

    communityScrollbutton.addEventListener('click', () => {
        gsap.to(window, {duration: 0.6, ease: "power4.easeInOut", scrollTo:"#js-scroll-destination"});
    });
}

const fourScrollbutton = document.querySelector('.js-404-scroll');

if (typeof fourScrollbutton != "undefined" && fourScrollbutton != null) {
    fourScrollbutton.addEventListener('click', () => {
        gsap.to(window, {duration: 0.6, ease: "power4.easeInOut", scrollTo:"#js-scroll-destination"});
    });
}